import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

const NotFound = () => (
  <div
    className="flex min-h-[70vh] items-center justify-center bg-paper px-6 pb-24 pt-32"
    data-testid="not-found-page"
  >
    <Seo title="Page not found — TecKube" description="The page you are looking for was moved or never existed." />
    <div className="text-center">
      <p className="font-mono text-sm tracking-[0.3em] text-primary">404</p>
      <h1 className="mt-5 font-display text-4xl font-semibold tracking-tight text-ink md:text-5xl">
        This page doesn&rsquo;t exist.
      </h1>
      <p className="mt-5 text-lg text-soot">The page you are looking for was moved or never existed.</p>
      <Link to="/" data-testid="not-found-home-link" className="btn btn-primary mt-10">
        Back to home
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </div>
);

export default NotFound;
